import { lazy } from 'react';
import Loadable from '../components/loading/Loadable';
import MinimalLayout from '../components/MinimalLayout'
import Dashboard from '../pages/dashboard';
import MapPage from '../pages/fromLoc';
import historyDriver from '../pages/historyDriver';
// project imports
// import ToLoc from '../pages/toLoc';
// import FromLoc from '../pages/fromLoc'
// login option 3 routing
const Login = Loadable(lazy(() => import('../pages/loginDriver')));
const FirstPage = Loadable(lazy(() => import('../pages/firstPage')));
const LoginSender = Loadable(lazy(() => import('../pages/loginSender')));
const ToLoc = Loadable(lazy(() => import('../pages/toLoc')));
const FromLoc = Loadable(lazy(() => import('../pages/fromLoc')));
const ToLocDriver = Loadable(lazy(() => import('../pages/driverToLoc')));
const FromLocDriver = Loadable(lazy(() => import('../pages/driverFromLoc')));
const Parcel = Loadable(lazy(() => import('../pages/parcel')));
const DriverDashboard = Loadable(lazy(() => import('../pages/driverDashboard')));
const Waiting = Loadable(lazy(() => import('../pages/waiting')));
const WaitingDriver = Loadable(lazy(() => import('../pages/driverWaiting')));
const History = Loadable(lazy(() => import('../pages/history')));

// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const routes = [
    {
        path: '/',
        component: FirstPage
    },
    {
        path: '/LoginSender',
        component: LoginSender
    },
    {
        path: '/LoginDriver',
        component: Login
    },
    {
        path: '/ToLoc',
        component: ToLoc
    },
    {
        path: '/waiting',
        component: Waiting
    },
    {
        path: '/waitingdriver',
        component: WaitingDriver
    },
    {
        path: '/FromLoc',
        component: FromLoc
    },
    {
        path: '/ToLocDriver',
        component: ToLocDriver
    },
    {
        path: '/driverDashboard',
        component: DriverDashboard
    },
    {
        path: '/FromLocDriver',
        component: FromLocDriver
    },
    {
        path: '/dashboard',
        component: Dashboard
    },
    {
        path: '/parcel',
        component: Parcel
    },
    {
        path: '/history',
        component: History
    },
    {
        path: '/historyDriver',
        component: historyDriver
    }
];

export default routes;
